










































































































































































import Vue from 'vue';

import Accordion from "./Accordion.vue"
import JourneySummary from './JourneySummary.vue'
import {Component, Prop} from "vue-property-decorator";
import {IRefundStatusJourney, IRefundStatusResponse} from "./IRefundStatusJourney";
import {IJourneyDetails} from "./JourneyDetails";
import RefundWarning from "./RefundWarning.vue";
import InstantRefundOffer from "./InstantRefundOffer.vue";
import {ICrsConverter} from "./ICrsConverter";
import RefundUtil from './RefundUtil';

import Axios from "axios";
import Modal from "./Modal.vue";
import JourneyPickerModal from "./JourneyPickerModal.vue";
import AppealsEmail from "./AppealsEmail.vue";
import {IRefundSuccess} from "./IRefundSuccess";
import {LookupJourneyResponse, LookupJourneyResponseItem, LookupJourneysRequest} from "./lookup-journeys";
import {ConfirmRefundRequest, FetchError} from "./RefundView.vue";

@Component({
        components: {
            JourneyPickerModal,
            InstantRefundOffer,
            RefundWarning,
            JourneySummary,
            Accordion,
            Modal,
            AppealsEmail
        }
    })
    export default class RefundWithReplacement extends Vue {
        @Prop() refundStatus: IRefundStatusJourney;
        @Prop() details: IJourneyDetails;
        @Prop() crsConverter: ICrsConverter;
        @Prop() currencyFormatter: Intl.NumberFormat;
        @Prop() protectedReference: string;
        @Prop() canAppeal: boolean;
        @Prop() appealsEmail: string;
        @Prop() dryRunRefund: IRefundSuccess;
        bookingReference: string = "";

        appealModalVisible: boolean = false;
        email: string = "";
        loading: boolean = false;
        lookupError: string = null;
        retrievedJourneys: Array<LookupJourneyResponseItem> = null;
        refundUtil = new RefundUtil();
        replacementStatusResponse: IRefundStatusResponse = null;

        mounted() {
            // assume that the user will probably have re-used the
            // same email address for this booking too
            this.email = this.details.email;
        }

        uriEncode(s) {
            return encodeURIComponent(s);
        }

        private validateBookingReference(ev) {
            console.log("Checking book reference " + this.details.bookingReference + " = " + ev.target.value);
            if (this.details.bookingReference === ev.target.value) {
                ev.target.setCustomValidity("Cannot be the same as the original booking reference");
            } else {
                ev.target.setCustomValidity("");
            }
        }

        private lookupJourneys(ev) {
            if (!ev.target.checkValidity()) return;
            const req = new LookupJourneysRequest();
            req.bookingReference = this.bookingReference;
            req.email = this.email;
            this.$insProgress.start();
            this.loading = true;
            const flatMap = (f, arr) => arr.reduce((x, y) => [...x, ...f(y)], []);
            Axios.post<LookupJourneysRequest, Array<LookupJourneyResponse>>("/api/LookupJourneys", req).then(
                (response) => {
                    console.log("received response", response.data);
                    let deserialised = response.data as Array<LookupJourneyResponse>;
                    this.replacementStatusResponse = deserialised.length > 0 ? deserialised[0].refundStatus : null;
                    this.$insProgress.finish();
                    this.loading = false;

                    const journeyIsValidReplacement = (item: LookupJourneyResponseItem) => {
                        if (this.replacementStatusResponse.journeys.filter(j => j.journeyID === item.journeyID).length === 1) {
                            return true;
                        }
                        console.log("Discarding journey " + item.journeyID + " as a choice - couldn't find refund status");

                        return false; // has no refund status associated with it
                    };

                    this.retrievedJourneys = flatMap(r => r.journeyList, deserialised).filter(journeyIsValidReplacement);

                    if (this.retrievedJourneys.length === 0) {
                        this.lookupError = "No matching eligible journeys. Journeys must have been purchased prior to your original departure time.";
                        this.retrievedJourneys = null;
                    }
                }).catch(
                (error) => {
                    console.error(error);
                    this.$insProgress.finish();
                    this.loading = false;
                    this.lookupError = error.response.data;
                }
            );
        }
    }

    